import cn from 'classnames'

import { FC } from 'react'

import { ITweet } from './types'

import LikesIcon from './icons/icon-likes.svg'
import CommentsIcon from './icons/icon-comments.svg'

import styles from './styles.module.scss'

export const Tweet: FC<{
  tweet: ITweet
  toWrapStats?: boolean
}> = ({ toWrapStats, tweet }) => {
  const authorLink = `https://twitter.com/${tweet.authorId}`
  const tweetLink = `${authorLink}/status/${tweet.tweetId}`
  const replyAuthorLink = tweet.reply ? `https://twitter.com/${tweet.reply.authorId}` : ''
  const replyTweetLink = tweet.reply ? `${replyAuthorLink}/status/${tweet.reply.tweetId}` : ''

  return (
    <div>
      <div className={styles.tweet}>
        <div className={styles.head}>
          <a href={authorLink} target="_blank" rel="noopener noreferrer nofollow">
            <img className={styles.logo} src={tweet.logo} alt="AuthorLogo" width={46} height={46} />
          </a>
          <a href={authorLink} target="_blank" rel="noopener noreferrer nofollow">
            <div className={styles.author}>
              <div className={styles.authorName}>{tweet.authorName}</div>
              <div className={styles.authorId}>{`@${tweet.authorId}`}</div>
            </div>
          </a>
        </div>
        <a href={tweetLink} target="_blank" rel="noopener noreferrer nofollow">
          <div className={styles.text} dangerouslySetInnerHTML={{ __html: tweet.text.replace(/\n/g, '<br />') }}></div>
          {tweet.imageId && (
            <div>
              <img
                className={styles.image}
                src={`https://pbs.twimg.com/media/${tweet.imageId}?format=jpg&name=small`}
                alt="TweetImage"
              />
            </div>
          )}
        </a>
        {tweet.reply && (
          <div className={cn(styles.tweet, styles.tweetReply)}>
            <div className={styles.replyContent}>
              <div className={styles.head}>
                <img
                  className={styles.logo}
                  src={`https://pbs.twimg.com/profile_images/${tweet.reply.logo}`}
                  alt="ReplyLogo"
                />
                <a href={replyAuthorLink} target="_blank" rel="noopener noreferrer nofollow">
                  <div className={styles.author}>
                    <div className={styles.authorName}>{tweet.reply.authorName}</div>
                    <div className={styles.authorId}>{`@${tweet.reply.authorId}`}</div>
                  </div>
                </a>
              </div>
              <a href={replyTweetLink} target="_blank" rel="noopener noreferrer nofollow">
                <div
                  className={styles.text}
                  dangerouslySetInnerHTML={{ __html: tweet.reply.text.replace(/\n/g, '<br />') }}
                ></div>
              </a>
            </div>
            {tweet.reply.imageId && (
              <a href={replyTweetLink} target="_blank" rel="noopener noreferrer nofollow">
                <img
                  className={styles.image}
                  src={`https://pbs.twimg.com/media/${tweet.reply.imageId}?format=jpg&name=small`}
                  alt="ReplyImage"
                />
              </a>
            )}
          </div>
        )}
        <div className={styles.date}>{tweet.date}</div>
        <div className={cn(styles.statistics, { [styles.statisticsWrap]: toWrapStats })}>
          <div className={styles.likes}>
            <img src={LikesIcon} alt="LikesIcon" />
            <div>{tweet.likes > 0 ? tweet.likes : ''}</div>
          </div>
          <div className={styles.comments}>
            <img src={CommentsIcon} alt="CommentsIcon" />
            <div>
              {tweet.comments > 0
                ? `${tweet.comments} people are Tweeting about this`
                : `See ${tweet.authorName}'s other Tweets`}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
